<template lang="pug">
	aside.aside-menu(:style="{visibility: Creative.isSelectedCreativeLoaded() ? 'visible' : 'hidden', top: `${Layout.headerHeight}px`}")
		slot Aside
</template>

<script>

	import Screen 						from './../../mixins/screen';

	import { Creative } 					from './../../services/Creative';

	export default {
		name: 'SettingsPlane',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Selected Version Switched", "Selected Creative Fully Loaded", "Update Settings Content", "Creative Fully Loaded"]
		},
		components: {

		},
		data() {

			this.Creative = Creative;

			return {
				showed: true
			};

		},
		props: {
			fixed: {
				type: Boolean,
				default: false
			},
			display: {
				type: String,
				default: ''
			},
			offCanvas: {
				type: Boolean,
				default: true
			}
		},
		created() {

			this.collectData();

		},
		mounted: function () {
			this.isFixed(this.fixed);
			this.isOffCanvas(this.offCanvas);
		},
		methods: {
			collectData() {

			},
			isFixed(fixed) {
				fixed ? document.body.classList.add('aside-menu-fixed') : document.body.classList.remove('aside-menu-fixed');
				return fixed;
			},
			isOffCanvas(offCanvas) {
				offCanvas ? document.body.classList.add('aside-menu-off-canvas') : document.body.classList.remove('aside-menu-off-canvas');
			}
		}
	}
</script>

<style lang="sass" scoped>

	aside.aside-menu
		width: 390px

</style>
